import React from 'react';
import { AutocompleteInput, FormDataConsumer, required ,Labeled} from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { evaluateCondition } from "./evaluateCondition";
import { FunctionField, useRecordContext } from 'react-admin';


export const AdvancedSelectInput = ({
  field_meta,
  source_name,
  index,
  css_class,
  is_required
}) => {
  const meta = JSON.parse(field_meta);
  const choices = meta.choices || [];
  const requiredConditions = meta.requiredConditions || [];
  const logic = meta.logic || 'AND';
  const watchField = meta.watchField || null;
  const watchValue = meta.watchValue || null;

  return (
    <FormDataConsumer>
      {({ formData }) => {
        const dependentValue = evaluateCondition(formData, requiredConditions, logic);


        if (!dependentValue) return null;

        const isConditionallyRequired = true;
        const validate = is_required || isConditionallyRequired ? [required()] : [];
        const isDisabled = watchField ? formData[watchField] === watchValue : false;

        return (
          <AutocompleteInput
            source={source_name}
            fullWidth
            key={index}
            validate={validate}
            choices={choices}
            className={` ${css_class} `}
            disabled={isDisabled}
          />
        );
      }}
    </FormDataConsumer>
  );
};

export const AdvancedFilterInput = ({
  field_meta,
  source_name,
  index,
  css_class,
  is_required
}) => {
  const meta = JSON.parse(field_meta);
  const choices = meta.choices || [];



  return (
    <AutocompleteInput
      source={source_name}
      choices={choices}
      className={` ${css_class} `}
    />
  );


};





export const SelectDisplayField = ({
  field_meta,
  source_name,
  css_class
}) => {
  const record = useRecordContext();
  const meta = JSON.parse(field_meta);
  const choices = meta.choices || [];
  const requiredConditions = meta.requiredConditions || [];
  const logic = meta.logic || 'AND';

  const shouldShow = evaluateCondition(record, requiredConditions, logic);
  if (!shouldShow) return null;

  const renderChoice = () => {
    const choice = choices.find(c => c.id === record[source_name]);
    return choice ? choice.name : record[source_name];
  };

  return (
    <Labeled
                      sx={{
                        "& .RaLabeled-label": {
                          fontWeight: "bold",
                          fontSize: "14px",
                          color: "#000",
                          paddingBottom: "5px",
                          display: "block",
                        },
                      }}
                    >
    <FunctionField
      source={source_name}

      render={renderChoice}
      className={` ${css_class} `}
    />
    </Labeled>
  );
};